import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import { ShippingMethodsResults } from "@NA/Services/ADIShippingService";
import ShippingMethodState from "../Data/ADIShippingMethodState";

const initialState: ShippingMethodState = {
    isLoading: false,
    shippingMethods: null,
    deliveryMethodInProgress: false,
    updatePaymentMethod: undefined,
    updateDeliveryMethod: "primary",
    alternateAddressRemoved: false,
    promoAppliedBtnclicked: false,
    initialPickUpDate: "",
    updateOneHourPickup: "",
};

const reducer = {
    "Custom/loadShippingMethods": (draft: Draft<ShippingMethodState>, action: { result: ShippingMethodsResults }) => {
        draft.isLoading = true;
    },
    "Custom/DispatchCompleteGetShippingMethod": (
        draft: Draft<ShippingMethodState>,
        action: { shippingMethods: ShippingMethodsResults },
    ) => {
        draft.isLoading = false;
        draft.shippingMethods = action.shippingMethods;
    },
    "Custom/DeliveryMethodChanges/BeginLoading": (draft: Draft<ShippingMethodState>, action: { result: boolean }) => {
        draft.deliveryMethodInProgress = action.result;
    },
    "Custom/DeliveryMethodChanges/CompleteLoading": (
        draft: Draft<ShippingMethodState>,
        action: { result: boolean },
    ) => {
        draft.deliveryMethodInProgress = action.result;
    },
    "Custom/UpdatePaymentMethod": (draft: Draft<ShippingMethodState>, action: { result: undefined | string }) => {
        draft.updatePaymentMethod = action.result;
    },
    "Custom/UpdateOneHourPickup": (draft: Draft<ShippingMethodState>, action: { result: undefined | string }) => {
        draft.updateOneHourPickup = action.result;
    },
    "Custom/UpdateDeliveryMethod": (draft: Draft<ShippingMethodState>, action: { result: string }) => {
        draft.updateDeliveryMethod = action.result;
    },
    "Custom/IsAlternateAddressRemoved": (draft: Draft<ShippingMethodState>, action: { result: boolean }) => {
        draft.alternateAddressRemoved = action.result;
    },
    "Custom/PromoCodeAppliedBtnClicked": (draft: Draft<ShippingMethodState>, action: { result: boolean }) => {
        draft.promoAppliedBtnclicked = action.result;
    },
    "Custom/UpdateInitialPickupDate": (draft: Draft<ShippingMethodState>, action: { result: any }) => {
        draft.initialPickUpDate = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
